import axios from "axios";

// Test
  // const API = axios.create({ baseURL: "https://localhost:7257/api/" });
//Publish API
// cws-map.azurewebsites.net
const API = axios.create({ baseURL: "https://cws-map.azurewebsites.net/api/" });


export const fetchUploadValues = () => API.get("/Overview/GetAllTurbineData");

export const UpdateCoordinates = (formData) => 
API.post(`/Overview/Update`,formData)

export const updateEquipment = (id, updateEquipment) =>
API.patch(`/Turbine/${id}`, updateEquipment);




// not Used when files only stored online
//export const fetchValues = () => API.get("/Overview");
